/**
 * TanStack Query hooks for `igaming-funnel`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingFunnelQueryKeys,
	type CreateIgamingFunnelBody,
	type ListIgamingFunnelResponse,
	type IgamingFunnelRow,
} from "./api";

export function useIgamingFunnelList(): UseQueryResult<ListIgamingFunnelResponse, Error> {
	return useQuery({
		queryKey: igamingFunnelQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingFunnelCreate(): UseMutationResult<IgamingFunnelRow, Error, CreateIgamingFunnelBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingFunnelQueryKeys.all });
		},
	});
}

export function useIgamingFunnelDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingFunnelQueryKeys.all });
		},
	});
}
